import { render, staticRenderFns } from "./trawl-radio-group.vue?vue&type=template&id=830e5584"
import script from "./trawl-radio-group.vue?vue&type=script&lang=js"
export * from "./trawl-radio-group.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports